import { CircularLoader } from '@sanlam-glacier/app-common/components';
import './loading-page.style.scss';

export const LoadingPage = () => {
  return (
    <div className='page-circular-loader-container'>
      <div className='page-circular-loader'>
        <CircularLoader thickness={3} />
      </div>
    </div>
  );
};
